import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link } from "react-router-dom";
import walletimage from "../../../assets/wallet.png";
import waittimeleft from "../../../assets/time.png";

import { CiCircleQuestion } from "react-icons/ci";
import api from "../../../utils/api";
import { useSelector } from "react-redux";
import { FaPoundSign, FaSpinner } from "react-icons/fa";
import UserLogs from "../UserLogs/UserLogs";
import { showCustomAlert } from "../Signup/Toast";
const Wallet = () => {
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const [data, setData] = useState(null); // To store API response
  // console.log("🚀 ~ Wal ~ data:", data.data.data.estimatedTimeAt)
  const [loading, setLoading] = useState(true); // To handle loading state

  const [points, setPoints] = useState(0); // Initialize points state



  // const getUser = async ()=>{
  //   try {
  //     const response = await api.get(`/users/${user?._id}`)

  //     if (response?.data?.popUp) {
  //       showCustomAlert({
  //         title: "Congratulations!",
  //         html: "<p style='color: #555;'>You claimed points.</p>",
  //         icon: "success",
  //         timer : null,
  //         confirmButtonText: "Claim Points",
  //         confirmButtonColor: "#af313d",
  //         background: "#ffffff",
  //       });
  //       const response = await api.patch('/manualFund/claimPoints')
  //      }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const response = await api.get(`/current-points/user/${user._id}`); // API call
        setData(response);
        setPoints(response.data.data.currentPoint);
      } catch (error) {
        console.error("Error fetching points:", error);
      } finally {
        setLoading(false); // Mark loading as complete
      }
    };

    // getUser()
    setInterval(() => {
  
      fetchPoints();
    }, 2000);
    
  }, [user._id]);
  const calculateTimeLeft = (estimatedTimeAt) => {
    // Convert estimatedTimeAt to local date
    const estimatedDate = new Date(estimatedTimeAt);
    const currentDate = new Date(); // Local system timezone

    const estimatedTime = estimatedDate.getTime(); // Time in milliseconds
    const currentTime = currentDate.getTime();     // Current time in milliseconds

    const diffInMs = estimatedTime - currentTime;

    // Check if time is already passed
    if (diffInMs <= 0) {
        return "Time has already passed.";
    }

    // Convert milliseconds to days, hours, minutes, and seconds
    const diffInSeconds = Math.floor(diffInMs / 1000) % 60;
    const diffInMinutes = Math.floor((diffInMs / (1000 * 60)) % 60);
    const diffInHours = Math.floor((diffInMs / (1000 * 60 * 60)) % 24);
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays > 0) {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ${diffInHours} hour${diffInHours > 1 ? "s" : ""}`;
    } else if (diffInHours > 0) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""}`;
    } else {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""}`;
    }
};
const calculateRemainingTime = (estimatedTimeAt) => {
  // Convert estimatedTimeAt to local date
  const estimatedDate = new Date(estimatedTimeAt); 
  const currentDate = new Date(); // Local system timezone

  const estimatedTime = estimatedDate.getTime(); // Time in milliseconds
  const currentTime = currentDate.getTime();     // Current time in milliseconds

  const diffInMs = estimatedTime - currentTime;

  // Check if time is already passed
  if (diffInMs < 0) {
      return "Time already passed";
  }

  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInHours = Math.floor((diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const diffInMinutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

  let remainingTime = "";

  if (diffInDays > 0) {
      remainingTime += `${diffInDays} day${diffInDays > 1 ? "s" : ""} `;
  }

  if (diffInHours > 0) {
      remainingTime += `${diffInHours} hour${diffInHours > 1 ? "s" : ""} `;
  }

  if (diffInMinutes > 0) {
      remainingTime += `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""}`;
  }

  return remainingTime.trim();
};
// Example usage
// const estimatedTimeAt = "2024-12-28T07:09:41.119Z"; // Replace with your timestamp

// const remainingTime = calculateTimeLeft(estimatedTimeAt);
// console.log("Remaining time:", remainingTime);




  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
      <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
    </div>
    );
  }

  // if (!data || !data.data?.data) {
  //   return (
  //     <div className="px-8">
  //       <Link to="/dashboard">
  //         <GoArrowLeft className="md:text-[2rem] text-[1.5rem] sm:text-[1.5rem] cursor-pointer mt-4" />
  //       </Link>
  //       <div className="text-center mt-14">
  //         <h2 className="font-bold text-2xl">No Data Available</h2>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="px-8">
      <Link to="/dashboard">
        <GoArrowLeft className="md:text-[2rem] text-[1.5rem] sm:text-[1.5rem] cursor-pointer mt-4" />
      </Link>
      <div className="lg:max-w-[80%] sm:max-w-[80%] max-w-[90%] md:max-w-[80%] mx-auto p-4 bg-[#FAFAFA] rounded-xl shadow-sm mb-16 mt-14">
        <div className="w-[80%] lg:h-[73.22px] h-[44px] sm:h-[44px] md:h-[60px] flex items-center justify-center text-white body font-bold lg:text-[40px] text-[22px] sm:text-[22px] md:text-[30px] bg-[#AF313D] mx-auto">
          <button className="body">Available Balance</button>
        </div>
        <div className="flex justify-between items-center mx-auto w-[90%] mt-6">
          <div className="flex md:gap-6 gap-2 items-center">
            <div className="body lg:w-[90.98px] lg:h-[90.98px] sm:h-[30px] sm:w-[30px] h-[30px] w-[30px] md:h-[45px] md:w-[45px] bg-white flex items-center justify-center">
              <img src={walletimage} alt="" />
            </div>
            <h1 className="body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">Amount</h1>
          </div>
          <div className="flex items-center justify-center  md:gap-2 body font-semibold lg:text-[40px] text-[25px] sm:text-[25px] md:text-[30px]">
          <FaPoundSign  size={15} className="" /> {points || 0}
          </div>
        </div>
      </div>
      <div className="w-[80%] lg:h-[73.22px] h-[44px] sm:h-[44px] md:h-[60px] flex items-center justify-center text-white body font-bold lg:text-[40px] text-[22px] sm:text-[22px] md:text-[30px] bg-[#AF313D] mx-auto">
          <button>Cashback Status</button>
        </div>
      <div className="lg:max-w-[80%] sm:max-w-[80%] max-w-[90%] md:max-w-[80%] mx-auto p-4 bg-[#FAFAFA] rounded-xl shadow-sm mb-5">
        
        <UserLogs/>
        {/* <div className="flex justify-between items-center mx-auto w-[90%] mt-6">
          <h1 className="body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">CashBack ID</h1>
          <div className="flex gap-2 body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">
            <h1>{data?.data?.data?._id?.slice(-6)}</h1>
          </div>
        </div>
        <div className="flex justify-between items-center mx-auto w-[90%] mt-6">
          <h1 className="body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">Cashback Status</h1>
          <div className="flex gap-2 body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">
            {data?.data?.data?.currentPoint > 0 ? (
              <h1>Received</h1>
            ) : (
              <h1>Pending</h1>
            )}
          </div>
        </div> */}

        {/* <div className="flex justify-between items-center mx-auto w-[90%] mt-6">
          <h1 className="body font-semibold lg:text-[30px] text-[15px] sm:text-[15px] md:text-[25px]">Queue</h1>
          <div className="flex gap-2 body font-semibold lg:text-[40px] text-[25px] sm:text-[25px] md:text-[30px]">
            <h1>{data.data.data.queueNo}</h1>
          </div>
        </div>
        <div className="w-[80%] mt-5 flex items-center md:gap-5 gap-2 justify-center text-[#5c5b5b] body font-bold lg:text-[40px] text-[22px] sm:text-[22px] md:text-[30px] mx-auto">
          <CiCircleQuestion />
          <h1>Your turn is near!</h1>
        </div> */}
      </div>

      {/* <div className="lg:max-w-[80%] sm:max-w-[80%] max-w-[90%] md:max-w-[80%] mx-auto p-4 bg-[#FAFAFA] rounded-xl shadow-sm">
        <div className="w-[80%] lg:h-[73.22px] h-[44px] sm:h-[44px] md:h-[60px] flex items-center justify-center text-white body font-bold lg:text-[40px] text-[22px] sm:text-[22px] md:text-[30px] bg-[#AF313D] mx-auto">
          <button>Processing Time</button>
        </div>
        <div className="flex justify-between items-center mx-auto w-[90%] mt-6">
          <h1 className="body font-semibold lg:text-[30px] text-[12px] sm:text-[12px] md:text-[25px]">Estimated time</h1>
          <div className="flex gap-2 body font-semibold lg:text-[40px] text-[15px] sm:text-[15px] md:text-[30px]">
            <h1>{calculateRemainingTime(data?.data?.data?.estimatedTimeAt)}</h1>
          </div>
        </div>
      </div> */}
    {/* <Link to="/user-logs">
    <div className="w-[62%] lg:h-[73.22px] mt-6 h-[44px] sm:h-[44px] md:h-[60px] flex items-center justify-center text-white body font-bold lg:text-[40px] text-[22px] sm:text-[22px] md:text-[30px] bg-[#AF313D] mx-auto">
          <button>User Logs</button>
        </div>
    </Link> */}
    </div>
  );
};

export default Wallet;
